import App from '../containers/App'
import Home from '../containers/Home'
import PersonalInfo from '../containers/PersonalInfo'
import PersonalInfos from '../containers/PersonalInfos'
import Beneficiaries from '../containers/Beneficiaries'
import AccountsAndLoans from '../containers/AccountsAndLoans'
import PostAccountsAndLoans from '../containers/PostAccountsAndLoans'
import PreAccountsAndLoans from '../containers/PreAccountsAndLoans'
import LockedAccounts from '../containers/LockedAccounts'
import AccountTransactions from '../containers/AccountTransactions'
import PartnerPlans from '../containers/PartnerPlans'
import PartnerPlan from '../containers/PartnerPlan'
import MyPartnerPlans from '../containers/MyPartnerPlans'
import PartnerPlanOverview from '../containers/PartnerPlanOverview'
import ReviewPartnerPlans from '../containers/ReviewPartnerPlans'
import PartnerPlanRatingsUpload from '../containers/PartnerPlanRatingsUpload'
import PartnerPlanOLRatingsUpload from '../containers/PartnerPlanOLRatingsUpload'
import PartnerPlanFinalRatingsUpload from '../containers/PartnerPlanFinalRatingsUpload'
import PartnerPlanReminderNotification from '../containers/PartnerPlanReminderNotification'
import PartnerPlanReport from '../containers/PartnerPlanReport'
import BeneficiaryUpload from '../containers/BeneficiaryUpload'
import Documents from '../containers/Documents'
import Reports from '../containers/Reports'
import PersonalInfoView from '../views/PersonalInfo/PersonalInfoView'
import BeneficiariesView from '../views/Beneficiaries/Beneficiaries'
import AccountsAndLoansView from '../views/AccountsAndLoans/AccountsAndLoans'
import LockedAccountsView from '../views/AccountsAndLoans/LockedAccounts'
import PartnerPlansView from '../views/PartnerPlans/PartnerPlans'
import PartnerPlanView from '../views/PartnerPlans/PartnerPlan'
import PartnerPlanRatingsUploadView from '../views/PartnerPlans/PartnerPlanRatingsUpload'
import PartnerPlanOLRatingsUploadView from '../views/PartnerPlans/PartnerPlanOLRatingsUpload'
import PartnerPlanFinalRatingsUploadView from '../views/PartnerPlans/PartnerPlanFinalRatingsUpload'
import PartnerPlanReminderNotificationView from '../views/PartnerPlans/PartnerPlanReminderNotification'
import DetailedReportView from '../views/PartnerReports/PartnerPlan/DetailedReport'
import BeneficiaryUploadView from '../views/Beneficiaries/BeneficiaryUpload'
import DocumentsView from '../views/Documents/DocumentsView'
import DocumentsTax from '../containers/DocumentsTax'
import ReportsView from '../views/Reports/Reports'
import AdminCentre from '../views/AdminCentre/AdminCentre'
import NotFound from '../containers/NotFound'
import UnauthorisedPage from '../containers/UnauthorisedPage'
import ErrorPage from '../containers/ErrorPage'
import DocumentsOthers from '../containers/DocumentsOthers'
import DocumentsRemunerations from '../containers/DocumentsRemunerations'
import DocumentsCapitalLoan from '../containers/DocumentsCapitalLoan'
import DetailedReport from '../containers/DetailedReport'
import UploadLogs from '../containers/UploadLogs'
import UploadLogsView from '../views/UploadLogs/UploadLogsView'
import UploadLogsTax from '../containers/UploadLogsTax'
import UploadLogsRemunerations from '../containers/UploadLogsRemunerations'
import UploadLogsOthers from '../containers/UploadLogsOthers'
import UploadLogsCapitalLoans from '../containers/UploadLogsCapitalLoans'
import CapitalLoansTemplateUpload from '../containers/CapitalLoanTemplateUpload'
import CapitalLoanUploadView from '../views/TemplateUpload/CapitalLoanUpload'
import CapitalTrustDeedsTemplateUpload from '../containers/CapitalLoanTrustDeedTemplateUpload'
import CapitalLoanTrustDeedUploadView from '../views/TemplateUpload/CapitalLoanTrustDeedUpload'
import CapitalLoanAmtConfTemplateUpload from '../containers/CapitalLoanAmtConfTemplateUpload'
import CapitalLoanAmtConfUploadView from '../views/TemplateUpload/CapitalLoanAmtConfUpload'
import PartnerPlanAdmin from '../containers/PartnerPlanAdmin'
import PartnerPlanAdminView from '../views/PartnerPlans/PartnerPlanAdmin'
import PartnerPlanRatingVisibility from '../containers/PartnerPlanRatingVisibility'
import PartnerPlanRatingVisibilityView from '../views/PartnerPlans/PartnerPlanRatingVisibility'
import HierarchyUpload from '../containers/HierarchyUpload'
import HierarchyUploadView from '../views/PartnerHierarchy/HierarchyUpload'
import FeatureToggle from '../containers/FeatureToggle'
import FeatureToggleView from '../views/FeatureToggle/FeatureToggle'
import constants from 'constants'
import HierarchyPlanReportView from '../views/PartnerReports/PartnerPlan/HierarchyPlanReport'
// import DocusignTemplateUpload from '../containers/DocusignTemplateUpload'
// import DocusignUploadView from '../views/TemplateUpload/DocusignUpload'
// import UploadLogsDocusign from '../containers/UploadLogsDocusign'

const routes = [{
  path: '/',
  component: App,
  routes: [{
    path: '/',
    component: Home,
    exact: true,
  },
  {
    path: '/personalinfo',
    component: PersonalInfo,
    routes: [
      {
        path: '/personalinfo',
        component: PersonalInfoView,
        exact: true,
      },
    ],
  },
  {
    path: '/beneficiaries',
    component: Beneficiaries,
    routes: [
      {
        path: '/beneficiaries',
        component: BeneficiariesView,
        exact: true,
      },
    ],
  },
  {
    path: '/accountsandloans',
    component: AccountsAndLoans,
    routes: [
      {
        path: '/accountsandloans/post',
        component: PostAccountsAndLoans,
        name: 'Post Swift',
        routes: [
          {
            path: '/accountsandloans/post',
            component: AccountsAndLoansView,
            exact: true,
          },
        ],
      },
      {
        path: '/accountsandloans/pre',
        component: PreAccountsAndLoans,
        name: 'Pre Swift',
        routes: [
          {
            path: '/accountsandloans/pre',
            component: AccountsAndLoansView,
            exact: true,
          },
        ],
      },
      {
        path: '/accountsandloans/transactions',
        component: AccountTransactions,
        exact: true,
      },
    ],
  },
  {
    path: '/partnerplans',
    component: PartnerPlans,
    routes: [
      {
        path: '/partnerplans/overview',
        component: PartnerPlanOverview,
        name: 'Overview',
        data: { showSidebar: false },
        routes: [
          {
            path: '/partnerplans/overview',
            component: PartnerPlansView,
            exact: true,
          },
        ],
      },
      {
        path: '/partnerplans/myplans',
        component: MyPartnerPlans,
        name: 'My plans',
        routes: [
          {
            path: '/partnerplans/myplans',
            component: PartnerPlansView,
            exact: true,
          },
        ],
      },
      {
        path: '/partnerplans/review',
        component: ReviewPartnerPlans,
        name: 'Review',
        data: { showSidebar: false },
        routes: [
          {
            path: '/partnerplans/review',
            component: PartnerPlansView,
            exact: true,
          },
        ],
      },
    ],
  },
  {
    path: '/partnerplan/plan',
    component: PartnerPlan,
    routes: [
      {
        path: '/partnerplan/plan',
        component: PartnerPlanView,
        exact: true,
      },
    ],
  },
  {
    path: '/documents',
    component: Documents,
    routes: [
      {
        path: '/documents/taxstatements',
        component: DocumentsTax,
        name: 'Tax Statements',
        routes: [
          {
            path: '/documents/taxstatements',
            component: DocumentsView,
            exact: true,
          },
        ],
      },
      {
        path: '/documents/remunerations',
        component: DocumentsRemunerations,
        name: 'Remuneration',
        routes: [
          {
            path: '/documents/remunerations',
            component: DocumentsView,
            exact: true,
          },
        ],
      },
      {
        path: '/documents/others',
        component: DocumentsOthers,
        name: 'Other',
        routes: [
          {
            path: '/documents/others',
            component: DocumentsView,
            exact: true,
          },
        ],
      },
      {
        path: '/documents/capitalloan',
        component: DocumentsCapitalLoan,
        name: 'Capital Loan',
        routes: [
          {
            path: '/documents/capitalloan',
            component: DocumentsView,
            exact: true,
          },
        ],
      },
    ],
  },
  {
    path: '/reports/detailedreport',
    component: PartnerPlanReport,
    routes: [
      {
        path: '/reports/detailedreport',
        component: DetailedReportView,
        data: { showSidebar: false },
        exact: true,
      },
    ],
  },
  {
    path: '/reports/plan/ceo',
    component: PartnerPlanReport,
    routes: [
      {
        path: '/reports/plan/ceo',
        component: HierarchyPlanReportView,
        data: { showSidebar: false },
        reportSuffix: 'ceo_partnerplan_report',
        reportHeader: constants.PARTNERPLAN.ROLE.CEO,
        exact: true,
      },
    ],
  },
  {
    path: '/reports/plan/businessleader',
    component: PartnerPlanReport,
    routes: [
      {
        path: '/reports/plan/businessleader',
        component: HierarchyPlanReportView,
        data: { showSidebar: false },
        reportSuffix: 'businessleader_partnerplan_report',
        reportHeader: constants.PARTNERPLAN.ROLE.BL,
        exact: true,
      },
    ],
  },
  {
    path: '/reports/plan/businesscoo',
    component: PartnerPlanReport,
    routes: [
      {
        path: '/reports/plan/businesscoo',
        component: HierarchyPlanReportView,
        data: { showSidebar: false },
        reportSuffix: 'businesscoo_partnerplan_report',
        reportHeader: constants.PARTNERPLAN.ROLE.BUCOO,
        exact: true,
      },
    ],
  },
  {
    path: '/reports/plan/offeringportfolioleader',
    component: PartnerPlanReport,
    routes: [
      {
        path: '/reports/plan/offeringportfolioleader',
        component: HierarchyPlanReportView,
        data: { showSidebar: false },
        reportSuffix: 'offeringportfolio_partnerplan_report',
        reportHeader: constants.PARTNERPLAN.ROLE.OPL,
        exact: true,
      },
    ],
  },
  {
    path: '/reports/plan/offeringleader',
    component: PartnerPlanReport,
    routes: [
      {
        path: '/reports/plan/offeringleader',
        component: HierarchyPlanReportView,
        data: { showSidebar: false },
        reportSuffix: 'offering_partnerplan_report',
        reportHeader: constants.PARTNERPLAN.ROLE.OL,
        exact: true,
      },
    ],
  },
  {
    path: '/reports',
    component: Reports,
    routes: [
      {
        path: '/reports',
        component: ReportsView,
        exact: true,
      },
    ],
  },
  {
    path: '/detailedreport',
    component: DetailedReport,
  },
  {
    path: '/admin/admincentre/personalinfo',
    component: PersonalInfo,
    routes: [
      {
        path: '/admin/admincentre/personalinfo',
        component: PersonalInfoView,
        exact: true,
      },
    ],
  },
  {
    path: '/admin/admincentre/beneficiaries',
    component: Beneficiaries,
    routes: [
      {
        path: '/admin/admincentre/beneficiaries',
        component: BeneficiariesView,
        exact: true,
      },
    ],
  },
  {
    path: '/admin/admincentre/accountsandloans',
    component: AccountsAndLoans,
    routes: [
      {
        path: '/admin/admincentre/accountsandloans/post',
        component: PostAccountsAndLoans,
        name: 'Post Swift',
        routes: [
          {
            path: '/admin/admincentre/accountsandloans/post',
            component: AccountsAndLoansView,
            exact: true,
          },
        ],
      },
      {
        path: '/admin/admincentre/accountsandloans/pre',
        component: PreAccountsAndLoans,
        name: 'Pre Swift',
        routes: [
          {
            path: '/admin/admincentre/accountsandloans/pre',
            component: AccountsAndLoansView,
            exact: true,
          },
        ],
      },
      {
        path: '/admin/admincentre/accountsandloans/transactions',
        component: AccountTransactions,
        exact: true,
      },
    ],
  },
  {
    path: '/admin/admincentre/partnerplans',
    component: PartnerPlans,
    routes: [
      {
        path: '/admin/admincentre/partnerplans/overview',
        component: PartnerPlanOverview,
        name: 'Overview',
        data: { showSidebar: false },
        routes: [
          {
            path: '/admin/admincentre/partnerplans/overview',
            component: PartnerPlansView,
            exact: true,
          },
        ],
      },
      {
        path: '/admin/admincentre/partnerplans/myplans',
        component: MyPartnerPlans,
        name: 'My plans',
        routes: [
          {
            path: '/admin/admincentre/partnerplans/myplans',
            component: PartnerPlansView,
            exact: true,
          },
        ],
      },
      {
        path: '/admin/admincentre/partnerplans/review',
        component: ReviewPartnerPlans,
        name: 'Review',
        data: { showSidebar: false },
        routes: [
          {
            path: '/admin/admincentre/partnerplans/review',
            component: PartnerPlansView,
            exact: true,
          },
        ],
      },
    ],
  },
  {
    path: '/admin/admincentre/beneficiary/upload',
    component: BeneficiaryUpload,
    routes: [
      {
        path: '/admin/admincentre/beneficiary/upload',
        component: BeneficiaryUploadView,
        exact: true,
      },
    ],
  },  
  {
    path: '/admin/admincentre/partnerplan/ratingvisibility',
    component: PartnerPlanRatingVisibility,
    routes: [
      {
        path: '/admin/admincentre/partnerplan/ratingvisibility',
        component: PartnerPlanRatingVisibilityView,
        exact: true,
      },
    ],
  },
  {
    path: '/admin/admincentre/partnerplan/ratingsupload',
    component: PartnerPlanRatingsUpload,
    routes: [
      {
        path: '/admin/admincentre/partnerplan/ratingsupload',
        component: PartnerPlanRatingsUploadView,
        exact: true,
      },
    ],
  },
  {
    path: '/admin/admincentre/partnerplan/olratingsupload',
    component: PartnerPlanOLRatingsUpload,
    routes: [
      {
        path: '/admin/admincentre/partnerplan/olratingsupload',
        component: PartnerPlanOLRatingsUploadView,
        exact: true,
      },
    ],
  },
  {
    path: '/admin/admincentre/partnerplan/finalratingsupload',
    component: PartnerPlanFinalRatingsUpload,
    routes: [
      {
        path: '/admin/admincentre/partnerplan/finalratingsupload',
        component: PartnerPlanFinalRatingsUploadView,
        exact: true,
      },
    ],
  },
  {
    path: '/admin/admincentre/partnerplan/remindernotification/interim',
    component: PartnerPlanReminderNotification,
    routes: [
      {
        path: '/admin/admincentre/partnerplan/remindernotification/interim',
        component: PartnerPlanReminderNotificationView,
        data: { notification: 'interim' },
        exact: true,
      },
    ],
  },
  {
    path: '/admin/admincentre/partnerplan/remindernotification/final',
    component: PartnerPlanReminderNotification,
    routes: [
      {
        path: '/admin/admincentre/partnerplan/remindernotification/final',
        component: PartnerPlanReminderNotificationView,
        data: { notification: 'final' },
        exact: true,
      },
    ],
  },
  {
    path: '/admin/admincentre/partnerplan/plan',
    component: PartnerPlan,
    routes: [
      {
        path: '/admin/admincentre/partnerplan/plan',
        component: PartnerPlanView,
        exact: true,
      },
    ],
  },
  {
    path: '/admin/admincentre/documents',
    component: Documents,
    routes: [
      {
        path: '/admin/admincentre/documents/taxstatements',
        component: DocumentsTax,
        name: 'Tax Statements',
        routes: [
          {
            path: '/admin/admincentre/documents/taxstatements',
            component: DocumentsView,
            exact: true,
          },
        ],
      },
      {
        path: '/admin/admincentre/documents/remunerations',
        component: DocumentsRemunerations,
        name: 'Remuneration',
        routes: [
          {
            path: '/admin/admincentre/documents/remunerations',
            component: DocumentsView,
            exact: true,
          },
        ],
      },
      {
        path: '/admin/admincentre/documents/others',
        component: DocumentsOthers,
        name: 'Other',
        routes: [
          {
            path: '/admin/admincentre/documents/others',
            component: DocumentsView,
            exact: true,
          },
        ],
      },
      {
        path: '/admin/admincentre/documents/capitalloan',
        component: DocumentsCapitalLoan,
        name: 'Capital Loan',
        routes: [
          {
            path: '/admin/admincentre/documents/capitalloan',
            component: DocumentsView,
            exact: true,
          },
        ],
      },
    ],
  },
  {
    path: '/admin/admincentre/uploadlogs',
    component: UploadLogs,
    routes: [
      {
        path: '/admin/admincentre/uploadlogs/taxstatements',
        component: UploadLogsTax,
        name: 'Tax Statements',
        routes: [
          {
            path: '/admin/admincentre/uploadlogs/taxstatements',
            component: UploadLogsView,
            exact: true,
          },
        ],
      },
      {
        path: '/admin/admincentre/uploadlogs/remunerations',
        component: UploadLogsRemunerations,
        name: 'Remuneration',
        routes: [
          {
            path: '/admin/admincentre/uploadlogs/remunerations',
            component: UploadLogsView,
            exact: true,
          },
        ],
      },
      {
        path: '/admin/admincentre/uploadlogs/others',
        component: UploadLogsOthers,
        name: 'Other',
        routes: [
          {
            path: '/admin/admincentre/uploadlogs/others',
            component: UploadLogsView,
            exact: true,
          },
        ],
      },
      {
        path: '/admin/admincentre/uploadlogs/capitalloans',
        component: UploadLogsCapitalLoans,
        name: 'Capital loan',
        routes: [
          {
            path: '/admin/admincentre/uploadlogs/capitalloans',
            component: UploadLogsView,
            exact: true,
          },
        ],
      },      
    ],
  },
  {
    path: '/admin/admincentre/templateupload/capitalloantrustdeeds',
    component: CapitalTrustDeedsTemplateUpload,
    routes: [
      {
        path: '/admin/admincentre/templateupload/capitalloantrustdeeds',
        component: CapitalLoanTrustDeedUploadView,
        exact: true,
      },
    ],
  },
  {
    path: '/admin/admincentre/templateupload/capitalloanpack',
    component: CapitalLoansTemplateUpload,
    routes: [
      {
        path: '/admin/admincentre/templateupload/capitalloanpack',
        component: CapitalLoanUploadView,
        exact: true,
      },
    ],
  },
  {
    path: '/admin/admincentre/templateupload/capitalloanamtconfirmation',
    component: CapitalLoanAmtConfTemplateUpload,
    routes: [
      {
        path: '/admin/admincentre/templateupload/capitalloanamtconfirmation',
        component: CapitalLoanAmtConfUploadView,
        exact: true,
      },
    ],
  },
  {
    path: '/admin/reports',
    component: Reports,
    routes: [
      {
        path: '/admin/reports',
        component: ReportsView,
        exact: true,
      },
    ],
  },
  {
    path: '/admin/detailedreport',
    component: DetailedReport,
  },
  {
    path: '/admin/admincentre/lockedaccount',
    component: LockedAccounts,
    routes: [
      {
        path: '/admin/admincentre/lockedaccount',
        component: LockedAccountsView,
        exact: true,
      },
    ],
  },
  {
    path: '/admin/admincentre/hierarchy/upload',
    component: HierarchyUpload,
    routes: [
      {
        path: '/admin/admincentre/hierarchy/upload',
        component: HierarchyUploadView,
        exact: true,
      },
    ],
  },
  {
    path: '/admin/admincentre/partnerplan/manage',
    component: PartnerPlanAdmin,
    routes: [
      {
        path: '/admin/admincentre/partnerplan/manage',
        component: PartnerPlanAdminView,
        exact: true,
      },
    ],
  },
  {
    path: '/admin/admincentre/featuretoggle',
    component: FeatureToggle,
    routes: [
      {
        path: '/admin/admincentre/featuretoggle',
        component: FeatureToggleView,
        exact: true,
      },
    ],
  },
  {
    path: '/admin/admincentre',
    component: PersonalInfos,
    routes: [
      {
        path: '/admin/admincentre',
        component: AdminCentre,
        exact: true,
      },
    ],
  },
  {
    path: '/error',
    component: ErrorPage,
  },
  {
    path: '/unauthorised',
    component: UnauthorisedPage,
  },
  {
    component: NotFound,
  },
  ],
}]

export default function getRoutes() {
  return routes
}



// WEBPACK FOOTER //
// ./src/routes/index.js